import { AssetsSection } from './components/AssetsSection'
import { FooterSection } from './components/FooterSection'
import { Hero } from './components/Hero'
import { NavBar } from './components/NavBar'
import { PerformanceSection } from './components/PerformanceSection'
import { PipelineSection } from './components/PipelineSection'
import { StartSection } from './components/StartSection'
import { ValidationSection } from './components/ValidationSection'

/**
 * Order: what it makes → how it makes it → how it's checked → how fast → how to
 * start. The pipeline sits second because it is the product's actual argument;
 * the asset list only means something once you know there's a context engine
 * behind it.
 */
export function App() {
  return (
    <>
      {/* Persistent aurora behind everything — this is what the glass surfaces
          blur. Without it the whole page reads as flat panels. */}
      <div className="aurora" aria-hidden="true">
        <div className="aurora__blob aurora__blob--iris" />
        <div className="aurora__blob aurora__blob--aqua" />
        <div className="aurora__blob aurora__blob--rose" />
      </div>
      <div className="aurora__grain" aria-hidden="true" />

      <div className="relative z-10">
        <NavBar />
        <main id="top">
          <Hero />
          <AssetsSection />
          <PipelineSection />
          <ValidationSection />
          <PerformanceSection />
          <StartSection />
        </main>
        <FooterSection />
      </div>
    </>
  )
}
